const Jwt = require('jsonwebtoken');

let Token = {
    username: 'submit-user',
    secret: 'c18904b1184842dfb0354cfbed4a809a',
    en(str = this.username) { //加密
        let createDate = Math.floor(Date.now() / 1000);
        let token = Jwt.sign({
            username: str,
            exp: createDate + 60,
            iat: createDate
        }, this.secret)
        sessionStorage.setItem('v2-token',token);
        return token
    },
    de(token) { //解密
        try {
            Jwt.verify(token, this.secret);
        } catch (error) {
            sessionStorage.removeItem('v2-token');
            this.en();
        }
    }
}

module.exports = Token;